<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <div class="dengJi p-10">
            <div>
              <h3>查重结果批量登记（导入）</h3>
            </div>
            <div class="m-t-15">


              <el-form ref="ruleForm" v-show="isUploadSuccess" :model="form">
                <el-form-item
                  prop="attachCode"
                  :rules="[
                    {
                      required: true,
                      message: '稿件附件必须上传',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-upload v-model="form.attachCode" :action="uploadURL" :before-upload="uploadBefore" ref="fileUpload" :multiple="true" name="file" list-type="text" :headers="uploadHeaders" :on-success="uploadSuccess">
                    <el-button size="small" type="primary"> 点击选择文件并上传… </el-button>
                  </el-upload>
                </el-form-item>

                <span style="font-size: 12px">只能上传xls/xlsx文件，且不超过5MB</span>
              </el-form>

              <div class="uploading" v-show="!isUploadSuccess">
                 <i class="el-icon-loading"></i>正在上传登记中，请等待！
              </div>
            </div>
            <!--div>
              <p style="font-size: 12px; margint-bottom: 0"><img class="xls" src="@/assets/xls.png" />登记模板文件 <a :href="importTemplateFile" target="_blank" class="download">下载</a></p>
            </div-->
          </div>
        </el-col>
      </el-row>


    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import http from "@/api/http"
import { getToken } from "@/utils/auth"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿，21作者一次改稿,22编辑第二次审稿。
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [{ path: "", title: "查重结果登记" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      drawer: false,
      drawerTitle: "",
      flag: false,
      curArticleId: 0,

      form: {
        attachId: 0,
        attachCode: "",
      },
      uploadHeaders: { Authorization: getToken() },
      isUploadSuccess:true,
      importTemplateFile:""
    }
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "recheck/article/excelImport"
    this.importTemplateFile = http.defaults.baseURL + "download/cha.xlsx"
  },

  mounted() {
  },

  methods: {
    uploadBefore(file) {
      console.log(file.type);
      const isDOC = file.type === "application/vnd.ms-excel"
      const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isDOC && !isDOCX) {
        this.$alert("不是XLS/XLSX 格式!", "系统提示", {
          confirmButtonText: "确定",
        })
        return false
      }
      if (!isLt5M) {
        this.$alert("上传文件不能超过 5MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return (isDOC || isDOCX) && isLt5M
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("登记导入失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
      } else {
        this.$notify.success({
          title: "登记导入成功",
          message: res.msg,
        });
        this.isUploadSuccess = true;
      }
    },

    uploadProgress(){
      this.isUploadSuccess = false;
    },

  },
}
</script>


<style scoped>
.dengJi {
  border: 1px solid #ccc;
  margin-bottom: 25px;
}
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}
.uploading{
  padding: 15px;
  font-size: 12px;
}
</style>